export default __webpack_public_path__ + "static/media/home-design-agency-img-02.cea99491.jpg";